/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import QuestionDto from './QuestionDto';

/**
 * The PaginatedQuestionsDto model module.
 * @module model/PaginatedQuestionsDto
 * @version v0
 */
class PaginatedQuestionsDto {
    /**
     * Constructs a new <code>PaginatedQuestionsDto</code>.
     * @alias module:model/PaginatedQuestionsDto
     */
    constructor() { 
        
        PaginatedQuestionsDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedQuestionsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedQuestionsDto} obj Optional instance to populate.
     * @return {module:model/PaginatedQuestionsDto} The populated <code>PaginatedQuestionsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedQuestionsDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('questions')) {
                obj['questions'] = ApiClient.convertToType(data['questions'], [QuestionDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedQuestionsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedQuestionsDto</code>.
     */
    static validateJSON(data) {
        if (data['questions']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['questions'])) {
                throw new Error("Expected the field `questions` to be an array in the JSON data but got " + data['questions']);
            }
            // validate the optional field `questions` (array)
            for (const item of data['questions']) {
                QuestionDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedQuestionsDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedQuestionsDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedQuestionsDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedQuestionsDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/QuestionDto>} questions
 */
PaginatedQuestionsDto.prototype['questions'] = undefined;






export default PaginatedQuestionsDto;

